// extracted by mini-css-extract-plugin
export default {"minPriceContainer":"min_price_panel_minPriceContainer__8ORWh","minPriceContent":"min_price_panel_minPriceContent__l5CsW","minPrice":"min_price_panel_minPrice__I8xp4"};